// src/locales/si/categories.js
export const categories = {
  // Page titles and descriptions
  title: "නිෂ්පාදන කාණ්ඩ",
  description: "වඩා හොඳ කළමනාකරණය සඳහා ශ්‍රේණිගත කාණ්ඩ සමඟ ඔබේ නිෂ්පාදන සංවිධානය කරන්න",
  
  // Navigation
  addCategory: "කාණ්ඩය එක් කරන්න",
  createNewCategory: "නව කාණ්ඩයක් සාදන්න",
  editCategory: "කාණ්ඩය සංස්කරණය කරන්න",
  createFirstCategory: "පළමු කාණ්ඩය සාදන්න",
  allCategories: "සියලුම කාණ්ඩ",
  
  // Form Fields
  categoryName: "කාණ්ඩ නාමය",
  categoryNamePlaceholder: "කාණ්ඩ නාමය ඇතුළත් කරන්න (උදා: ඉලෙක්ට්‍රොනික්ස්, ඇඳුම්)",
  parentCategory: "මව් කාණ්ඩය",
  selectParentCategory: "මව් කාණ්ඩය තෝරන්න (විකල්ප)",
  
  // Search and Navigation
  searchCategories: "කාණ්ඩ සොයන්න...",
  createUnder: "යටතේ සාදන්න",
  
  // Table Headers and Info
  totalCategories: "කාණ්ඩ {{count}}",
  
  // Validation Messages
  nameRequired: "කාණ්ඩ නාමය අවශ්‍යයි",
  nameMinLength: "කාණ්ඩ නාමය අවම වශයෙන් අක්ෂර 2ක් විය යුතුයි",
  
  // Actions
  createCategory: "කාණ්ඩය සාදන්න",
  updateCategory: "කාණ්ඩය යාවත්කාලීන කරන්න",
  
  // Success/Error Messages
  categoryCreatedSuccess: "'{{categoryName}}' කාණ්ඩය සාර්ථකව සාදන ලදී!",
  categoryUpdatedSuccess: "'{{categoryName}}' කාණ්ඩය සාර්ථකව යාවත්කාලීන කරන ලදී!",
  categoryDeletedSuccess: "'{{categoryName}}' කාණ්ඩය සාර්ථකව මකා දමා ඇත.",
  failedToCreate: "කාණ්ඩය සෑදීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
  failedToUpdate: "කාණ්ඩය යාවත්කාලීන කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
  failedToDelete: "කාණ්ඩය මකා දැමීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
  failedToLoadCategory: "කාණ්ඩ විස්තර පූරණය කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
  
  // Loading states
  loadingCategories: "කාණ්ඩ පූරණය වෙමින්...",
  loadingCategoriesDesc: "කරුණාකර අපි ඔබේ නිෂ්පාදන කාණ්ඩ ලබා ගන්නා තෙක් රැඳී සිටින්න.",
  
  // Empty states
  noCategories: "තවම කාණ්ඩ නැත",
  noCategoriesDesc: "ඔබේ නිෂ්පාදන සංවිධානය කිරීම ආරම්භ කිරීමට ඔබේ පළමු නිෂ්පාදන කාණ්ඩය සාදන්න.",
  noSearchResults: "කාණ්ඩ හමු නොවීය",
  noSearchResultsDesc: "ඔබේ සෙවුම් පද සකස් කිරීමට උත්සාහ කරන්න හෝ සියලුම කාණ්ඩ බැලීමට පෙරහන් ඉවත් කරන්න.",
  
  // Confirmation dialogs
  confirmDelete: "ඔබට විශ්වාසද '{{categoryName}}' කාණ්ඩය මකා දැමීමට? මෙම ක්‍රියාව අහෝසි කළ නොහැකි අතර මෙම කාණ්ඩය භාවිතා කරන නිෂ්පාදන වලට බලපෑ හැකිය."
};